import { X } from "lucide-react";

/** iter447 pt 5 / iter448 4c — bouton ✕ commun des fenêtres maison (hors ui/dialog) : 28×28, rayon 8, bordure #33333B, icône #9A9AA2,
 *  toujours en flux dans la rangée flex de l'en-tête (après la pastille éventuelle, écart 8 px), jamais en position absolue. */
export default function DeskCloseX({ onClick, testId = "dialog-close", title = "Fermer", style }) {
  return (
    <button type="button" onClick={onClick} title={title} aria-label={title} className="inline-flex items-center justify-center shrink-0 hover:bg-white/5" style={{ width: 28, height: 28, borderRadius: 8, border: "1px solid #33333B", color: "#9A9AA2", background: "transparent", marginLeft: 8, ...style }} data-testid={testId} data-desk-close="">
      <X size={14} />
    </button>
  );
}
